import {
  Box,
  Center,
  Text,
  Link
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Awareness() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >

        <Center>
          <Box
            w={{ base: "full", md: "4xl", xl: "6xl" }}
            pt={{ base: 20, md: 40 }}
            pb={{ base: 20, md: 60 }}
          >

            <SectionHeading
              title="Awareness"
              align={"center"}
            />
            <Text
              px={{ base: 4, md: 6 }}
              fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
            >
              <Lang text="Bear in mind that our social help has conditions and you must meet all requirements in order to be an AppOX beneficiary.  Read out our" /> &nbsp;
              <Link
                href="/termsandconditions"
              >
                <Text as={'span'} color={"#4aeade"}>
                  <Lang text="terms and conditions" />
                </Text>
              </Link>
              &nbsp;
              <Lang text="for more information." />
            </Text>
          </Box>

        </Center>
      </Box>
    </>
  );
}